// src/services/crud.service.js
import { router } from '@/router';
import store from '@/store/index';
import messageService from './message.service';
import responseService from './response.service';
import { stateProject } from "@/event-busProject";
import { state } from "@/event-bus";

import { api2 } from "@/lib/http"; // o api1

class CrudService {
  post = async (route, payload = {}, handle = { handleErrors: true, handleMessages: true }) => {
    try {
      const response = await api2.post(`/${route}`, payload);
      if (handle?.handleMessages) {
        const procesableResponse = responseService.processResponse(response);
        messageService.msgOk(procesableResponse.title, procesableResponse.message);
      }
      return response;
    } catch (error) {
      if (handle?.handleErrors) {
        const procesableError = responseService.processError(error);
        if (procesableError.statusCode === 401 || procesableError.statusCode === 403) {
          this.logout();
          throw error;
        }
        if (handle.handleMessages) {
          messageService.showResponseMessage(true, procesableError);
        }
      }
      throw error;
    }
  };

  get = async (route, params = undefined, handle = { handleErrors: true, handleMessages: true }) => {
    try {
      return await api2.get(`/${route}`, { params });
    } catch (error) {
      if (handle?.handleErrors) {
        const procesableError = responseService.processError(error);
        if (procesableError.statusCode === 401 || procesableError.statusCode === 403) {
          this.logout();
          throw error;
        }
        if (handle.handleMessages) {
          messageService.showResponseMessage(true, procesableError);
        }
      }
      throw error;
    }
  };

  put = async (route, payload = {}, handle = { handleErrors: true, handleMessages: true }) => {
    try {
      const response = await api2.put(`/${route}`, payload);
      if (handle?.handleMessages) {
        if (!state.pendingItem && stateProject.pendingProyecto && response.data?.message) {
          const procesableResponse = responseService.processResponse(response);
          messageService.msgOk(procesableResponse.title, procesableResponse.message);
        }
      }
      return response;
    } catch (error) {
      if (handle?.handleErrors) {
        const procesableError = responseService.processError(error);
        if (procesableError.statusCode === 401 || procesableError.statusCode === 403) {
          this.logout();
          throw error;
        }
        if (handle.handleMessages) {
          messageService.showResponseMessage(true, procesableError);
        }
      }
      throw error;
    }
  };

  delete = async (route, id, handle = { handleErrors: true, handleMessages: true }) => {
    try {
      const response = await api2.delete(`/${route}/${id}`);
      if (handle?.handleMessages) {
        const procesableResponse = responseService.processResponse(response);
        messageService.msgOk(procesableResponse.title, procesableResponse.message);
      }
      return response;
    } catch (error) {
      if (handle?.handleErrors) {
        const procesableError = responseService.processError(error);
        if (procesableError.statusCode === 401 || procesableError.statusCode === 403) {
          this.logout();
          throw error;
        }
        if (handle.handleMessages) {
          messageService.showResponseMessage(true, procesableError);
        }
      }
      throw error;
    }
  };

  logout() {
    store.dispatch('auth/logout');
    router.push('/login');
  }
}

export default new CrudService();
